<template>
  <div>
    <v-dialog
      v-model="isShowDialog"
      content-class="custom-loading-dialog"
      persistent
      width="340px"
      @click:outside="hideModal"
    >
      <v-row no-gutters>
        <v-col class="col-12 d-flex justify-center mt-12 pb-4">
          <v-btn fab color="modal_button" class="ex-large" v-show="false" v-ripple="{class: 'blue--text'}">PAY</v-btn>
        </v-col>
        <v-col class="col-12 d-flex justify-center mt-3">
          <v-btn fab color="modal_button" class="ex-large mt-12 mr-2" @click="showDialogObjectData">OBJECT <br> DATA</v-btn>
          <v-btn fab color="modal_button" class="ex-large" @click="$root.$emit('ShowAccount')">ACCOUNT</v-btn>
          <v-btn fab color="modal_button" class="ex-large mt-12 ml-2" @click="showNewUser">NEW USER</v-btn>
        </v-col>
        <v-col class="col-12 d-flex justify-space-between mt-3">
          <v-btn fab color="modal_button" class="ex-large" @click="showReports">REPORTS</v-btn>
          <v-btn fab color="modal_button" class="ex-large" @click="showPay">PAY</v-btn>
        </v-col>
        <v-col class="col-12 d-flex justify-center">
          <v-btn fab color="modal_button" class="ex-large mr-6" @click="showCharts">CHARTS</v-btn>
          <v-btn fab color="modal_button" class="ex-large ml-6" @click="showEvents">EVENTS</v-btn>
        </v-col>
        <v-col style="height: 240px"> </v-col>
      </v-row>
    </v-dialog>
    <Charts :isShowDialog="isShowDialogCharts" :device="device" @hideChart="isShowDialogCharts = false"></Charts>
    <Events :isShowDialog="isShowDialogEvents" :device="device" @hideEvents="isShowDialogEvents = false"></Events>
    <Reports :isShowDialog="isShowDialogReports" :device="device" @hideReports="isShowDialogReports = false"></Reports>
    <ObjectData :isShowDialog="isShowDialogObjectData" :device="device" @hideObjectData="isShowDialogObjectData = false"></ObjectData>
    <Pay :isShowDialog="isShowDialogPay" :device="device" @hidePay="isShowDialogPay = false"></Pay>
  </div>
</template>

<script>
  import Charts from './Charts.vue'
  import Events from './Events.vue'
  import Reports from './Reports.vue'
  import ObjectData from './ObjectData.vue'
  import Pay from './Pay.vue'
  import {mapGetters, mapActions, mapMutations} from 'vuex'
  export default {
    props: ['device', 'isShowDialog'],
    name: 'MarkerClick',
    data(){
      return {
        isShowDialogCharts: false,
        isShowDialogEvents: false,
        isShowDialogReports: false,
        isShowDialogObjectData: false,
        isShowDialogPay: false
      }
    },
    components:{
      Charts,
      Events,
      Reports,
      ObjectData,
      Pay
    },
    methods:{
      ...mapActions(['createUserByAgregator']),
      showNewUser(){
        this.$root.$emit('GrantAccess', this.device)
      },
      showDialogObjectData(){
        this.$root.$emit("showObjectData", this.device)
        this.isShowDialogObjectData = true
      },
      showReports(){
        this.$root.$emit("showReports", this.device)
        this.isShowDialogReports = true
      },  
      showEvents(){
        this.$root.$emit("showEvents", this.device)
        this.isShowDialogEvents = true
      },  
      showCharts(){
        this.$root.$emit("showChart", this.device)
        this.isShowDialogCharts = true
      },
      showPay(){
        console.log('showPay')
        this.$root.$emit("showPay", this.device)
        this.isShowDialogPay = true
      },
      hideModal(){
        console.log('HideMarkerClick')
        this.$emit("HideMarkerClick")
      }
    }
  }
</script>
<style >
.max-index{
  z-index: 10020 !important;
}
/*.modal_button:hover{
  color:  rgba(0, 0, 255, 0.75) !important;
  background-color: #FFFFFF !important;
}*/
</style>